/**
 * Theme metadata — dark (default) / light / system, plus unlockable accents.
 * Unlock thresholds are VERIFIED by the Server against behavior_balance;
 * these numbers exist client-side purely to render the locked/unlocked UI.
 */

import type { AccentTheme, ThemeMode } from "@/types/local";

export const THEME_MODES: { value: ThemeMode; label: string }[] = [
  { value: "system", label: "System Default" },
  { value: "dark", label: "Dark" },
  { value: "light", label: "Light" },
];

export interface AccentDefinition {
  value: AccentTheme;
  label: string;
  swatch: string;
  /** Behavior-point threshold; 0 = always available. */
  unlockThreshold: number;
}

export const ACCENT_THEMES: AccentDefinition[] = [
  { value: "default", label: "oStudent Blue", swatch: "#0095f6", unlockThreshold: 0 },
  { value: "neon-sapphire", label: "Neon Sapphire", swatch: "#00c6ff", unlockThreshold: 50 },
  { value: "emerald-fleet", label: "Emerald Fleet", swatch: "#2ecc71", unlockThreshold: 100 },
];

export function resolveThemeAttribute(mode: ThemeMode, systemPrefersDark: boolean): "dark" | "light" {
  if (mode === "system") return systemPrefersDark ? "dark" : "light";
  return mode;
}
